module.exports = __webpack_public_path__ + "img/4.b61c4f3d.webp";